import { PATH } from "Helpers/ats.constants";

export const Paths = {
  base: "/",
  nf: "*",

  // Public legal pages — reachable before and after login
  termsOfUse: "/terms-of-use",
  privacyPolicy: "/privacy-policy",
  dashboard: `/${PATH}/dashboard`,

  // Open Sales Orders
  openSalesOrders: `/${PATH}/open-sales-orders`,
  viewOpenSO: `/${PATH}/open-sales-orders/view/:order_id`,

  // Invoices
  invoices: `/${PATH}/invoices`,
  createInvoice: `/${PATH}/invoices/create/:so_id/:order_id`,
  createDirectInvoice: `/${PATH}/invoices/create`,
  editInvoice: `/${PATH}/invoices/edit/:invoice_no`,

  // User management
  users: `/${PATH}/manage-user`,
  addUser: `/${PATH}/manage-user/add-user`,
  editUser: `/${PATH}/manage-user/edit-user/:id`,

  // Roles
  roles: `/${PATH}/manage-role`,
  addRole: `/${PATH}/manage-role/add-role`,
  editRole: `/${PATH}/manage-role/edit-role/:id`,

  // Audit Trail (admin-only)
  auditLogs: `/${PATH}/audit-trail`,

  // Depots
  depots: `/${PATH}/manage-depot`,
  addDepot: `/${PATH}/manage-depot/add-depot`,
  editDepot: `/${PATH}/manage-depot/edit-depot/:id`,

  // WMS - Companies
  companies: `/${PATH}/manage-companies`,
  addCompany: `/${PATH}/manage-companies/add-company`,
  editCompany: `/${PATH}/manage-companies/edit-company/:id`,

  // WMS - Warehouse Zones
  zones: `/${PATH}/warehouse-layout/zones`,
  addZone: `/${PATH}/warehouse-layout/zones/add-zone`,
  editZone: `/${PATH}/warehouse-layout/zones/edit-zone/:id`,

  // WMS - Warehouse Bins
  bins: `/${PATH}/warehouse-layout/bins`,
  addBin: `/${PATH}/warehouse-layout/bins/add-bin`,
  editBin: `/${PATH}/warehouse-layout/bins/edit-bin/:id`,

  // WMS - Customers
  customers: `/${PATH}/manage-customers`,
  addCustomer: `/${PATH}/manage-customers/add-customer`,
  editCustomer: `/${PATH}/manage-customers/edit-customer/:id`,

  // WMS - Suppliers
  suppliers: `/${PATH}/manage-suppliers`,
  addSupplier: `/${PATH}/manage-suppliers/add-supplier`,
  editSupplier: `/${PATH}/manage-suppliers/edit-supplier/:id`,


  // WMS - Number Series
  numberSeries: `/${PATH}/number-series`,
  addNumberSeries: `/${PATH}/number-series/add-series`,
  editNumberSeries: `/${PATH}/number-series/edit-series/:id`,

  // WMS - Configurations
  configurations: `/${PATH}/system-config`,
  addConfiguration: `/${PATH}/system-config/add-config`,
  editConfiguration: `/${PATH}/system-config/edit-config/:id`,
  minInvoiceValues: `/${PATH}/system-config/min-invoice-values`,
  storeBrandRestrictions: `/${PATH}/system-config/store-brand-restrictions`,
  storeBlockList: `/${PATH}/system-config/store-block-list`,
  sapLogs: `/${PATH}/system-config/sap-logs`,
  announcements: `/${PATH}/system-config/announcements`,

  // WMS - Purchase Orders
  purchaseOrders: `/${PATH}/purchase-orders`,
  createPO: `/${PATH}/purchase-orders/create`,
  editPO: `/${PATH}/purchase-orders/edit/:id`,
  viewPO: `/${PATH}/purchase-orders/view/:id`,

  // Inter-Depot Purchase Orders
  interDepotPOs: `/${PATH}/inter-depot-po`,
  createPOFromPR: `/${PATH}/inter-depot-po/create`,
  editInterDepotPO: `/${PATH}/inter-depot-po/edit/:id`,
  viewInterDepotPO: `/${PATH}/inter-depot-po/view/:id`,
  interDepotInvoice: `/${PATH}/inter-depot-po/invoice/:po_id`,
  viewInterDepotInvoice: `/${PATH}/inter-depot-po/invoice/view/:invoice_no`,

  // WMS - GRN
  grnList: `/${PATH}/goods-receipt`,
  createGRN: `/${PATH}/goods-receipt/create`,
  viewGRN: `/${PATH}/goods-receipt/view/:id`,
  stoReceipt: `/${PATH}/goods-receipt/sto-receipt`,
  poReceipt: `/${PATH}/goods-receipt/po-receipt`,

  // WMS - Batches
  batches: `/${PATH}/batches`,

  // WMS - Stock
  stockOnHand: `/${PATH}/stock-management/on-hand`,
  stockMovements: `/${PATH}/stock-management/movements`,
  stockAdjustment: `/${PATH}/stock-management/adjustment`,
  openingStock: `/${PATH}/stock-management/opening-stock`,
  stockRegister: `/${PATH}/stock-management/register`,
  salesRegister: `/${PATH}/stock-management/sales-register`,
  purchaseRegister: `/${PATH}/stock-management/purchase-register`,
  productWiseSalesReport: `/${PATH}/stock-management/product-wise-sales-report`,

  // WMS Phase 2 - Sales Orders
  salesOrders: `/${PATH}/sales-orders`,
  createSO: `/${PATH}/sales-orders/create`,
  editSO: `/${PATH}/sales-orders/edit/:id`,
  viewSO: `/${PATH}/sales-orders/view/:id`,

  // WMS Phase 2 - Picking
  pickLists: `/${PATH}/picking`,
  createPickList: `/${PATH}/picking/create/:soId`,
  viewPickList: `/${PATH}/picking/view/:id`,

  // WMS Phase 2 - Dispatch
  dispatches: `/${PATH}/dispatch`,
  createDispatch: `/${PATH}/dispatch/create`,
  viewDispatch: `/${PATH}/dispatch/view/:id`,

  // WMS Phase 2 - WMS Invoices
  wmsInvoices: `/${PATH}/wms-invoices`,
  viewWmsInvoice: `/${PATH}/wms-invoices/view/:id`,

  // WMS Phase 2 - Credit Notes
  creditNotes: `/${PATH}/credit-notes`,
  createCreditNote: `/${PATH}/credit-notes/create`,
  viewCreditNote: `/${PATH}/credit-notes/view/:id`,

  // WMS Phase 2 - Debit Notes
  debitNotes: `/${PATH}/debit-notes`,
  createDebitNote: `/${PATH}/debit-notes/create`,
  viewDebitNote: `/${PATH}/debit-notes/view/:id`,

  // WMS Phase 2 - Payments
  payments: `/${PATH}/payments`,
  createPayment: `/${PATH}/payments/create`,
  viewPayment: `/${PATH}/payments/view/:id`,

  // WMS Phase 2 - Sales Returns
  salesReturns: `/${PATH}/sales-returns`,
  createSalesReturn: `/${PATH}/sales-returns/create`,
  viewSalesReturn: `/${PATH}/sales-returns/view/:id`,

  // Depo Returns (depot-side return invoices — walk-in or POS-originated)
  depoReturns: `/${PATH}/depo-returns`,
  createDepoReturn: `/${PATH}/depo-returns/create`,
  editDepoReturn: `/${PATH}/depo-returns/edit/:id`,
  viewDepoReturn: `/${PATH}/depo-returns/view/:id`,
  posReturnSOsList: `/${PATH}/depo-returns/pos/open`,
  posReturnSOImport: `/${PATH}/depo-returns/pos/import/:return_order_id`,

  // WMS Phase 3 - Putaway
  putawayTasks: `/${PATH}/putaway`,
  viewPutaway: `/${PATH}/putaway/view/:id`,

  // WMS Phase 3 - Shelf Transfers
  shelfTransfers: `/${PATH}/shelf-transfers`,
  createShelfTransfer: `/${PATH}/shelf-transfers/create`,
  viewShelfTransfer: `/${PATH}/shelf-transfers/view/:id`,

  // WMS Phase 3 - Cycle Counts
  cycleCounts: `/${PATH}/cycle-counts`,
  createCycleCount: `/${PATH}/cycle-counts/create`,
  viewCycleCount: `/${PATH}/cycle-counts/view/:id`,

  // Purchase Requests
  purchaseRequests: `/${PATH}/purchase-requests`,
  createPR: `/${PATH}/purchase-requests/create`,
  editPR: `/${PATH}/purchase-requests/edit/:id`,
  viewPR: `/${PATH}/purchase-requests/view/:id`,
  depotPRMappings: `/${PATH}/purchase-requests/depot-mappings`,

  // WMS Phase 3 - Stock Transfers
  stockTransfers: `/${PATH}/stock-transfers`,
  createStockTransfer: `/${PATH}/stock-transfers/create`,
  viewStockTransfer: `/${PATH}/stock-transfers/view/:id`,
  receiveStockTransfer: `/${PATH}/stock-transfers/receive/:id`,

  // WMS Phase 3 - Stock Levels & Alerts
  stockLevels: `/${PATH}/stock-levels`,
  stockAlerts: `/${PATH}/stock-alerts`,

  // WMS Phase 3 - Expiry Management
  expiryDashboard: `/${PATH}/expiry-management`,
  expirySettings: `/${PATH}/expiry-management/settings`,

  // Retail — Depot counter sales to AB / RB / DW / Normal
  saleBills: `/${PATH}/sale-bills`,
  createSaleBill: `/${PATH}/sale-bills/create`,
  // Path A: literal-port POS Sale Bill GUI; mounted side-by-side as a
  // preview while we iterate (the original createSaleBill above stays as
  // the fallback). Drop the original once parity is confirmed.
  createSaleBillPos: `/${PATH}/sale-bills/create-pos`,
  viewSaleBill: `/${PATH}/sale-bills/view/:invoice_no`,

  // Retail — Sale Return
  saleReturns: `/${PATH}/sale-returns`,
  createSaleReturn: `/${PATH}/sale-returns/create/:original_invoice_no`,
  viewSaleReturn: `/${PATH}/sale-returns/view/:invoice_no`,
};

export const redirectionExcludedPaths = [];
